<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选学校">
                        <el-select v-model="filter.school_id" clearable placeholder="请选择学校" filterable remote
                                   :remote-method="handleSearchSchool"
                                   @change="handleList"
                                   >
                            <el-option
                                    v-for="item in schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选年级">
                        <el-select v-model="filter.grade_id" clearable placeholder="请选择年级" @change="handleList">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选班主任" v-if="powers.includes(180)">
                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任" filterable remote
                                   @change="handleList"
                                   :remote-method="handleSearchHeadTeacher">
                            <el-option
                                    v-for="item in headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item label="筛选学生">
                        <el-select v-model="filter.student_id" clearable placeholder="请选择学生" filterable remote
                                   :remote-method="handleSearchStudent"
                                   @change="handleList"
                        >
                            <el-option
                                    v-for="item in students"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button @click="handleExcel()" >导出Excel</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="right m-b-0" :style="{'height':clientHeight-96+'px'}" >
            <vue-scroll :ops="$ops" >
                <div style="display: flex; flex-direction: row; flex-wrap: nowrap">
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        未开始-{{no_start_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}" >
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(no_start_student,index) in no_start_students" :key="index" style="height: 60px">
                                    <div class="item" @click="handleRenewDetail(no_start_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{no_start_student.name}}
                                                </div>
                                                <div>
                                                    {{no_start_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{no_start_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleNoStartStudentSizeChange"
                                            @current-change="handleNoStartStudentCurrentChange"
                                            :current-page="no_start_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="no_start_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        犹豫-{{hesitate_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding"  :style="{'height':clientHeight-186+'px'}">
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(hesitate_student,index) in hesitate_students" :key="index" >
                                    <div class="item"  @click="handleRenewDetail(hesitate_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{hesitate_student.name}}
                                                </div>
                                                <div>
                                                    {{hesitate_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{hesitate_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleHesitateStudentSizeChange"
                                            @current-change="handleHesitateStudentCurrentChange"
                                            :current-page="hesitate_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="hesitate_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        预约到店-{{appoint_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}">
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(appoint_student,index) in appoint_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(appoint_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{appoint_student.name}}
                                                </div>
                                                <div>
                                                    {{appoint_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{appoint_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleAppointStudentSizeChange"
                                            @current-change="handleAppointStudentCurrentChange"
                                            :current-page="appoint_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="appoint_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        已明确意向-{{clearIntention_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}">
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(clearIntention_student,index) in clearIntention_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(clearIntention_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{clearIntention_student.name}}
                                                </div>
                                                <div>
                                                    {{clearIntention_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{clearIntention_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleClearIntentionStudentSizeChange"
                                            @current-change="handleClearIntentionStudentCurrentChange"
                                            :current-page="clearIntention_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="clearIntention_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        催费-{{rushFee_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}">
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(rushFee_student,index) in rushFee_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(rushFee_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{rushFee_student.name}}
                                                </div>
                                                <div>
                                                    {{rushFee_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{rushFee_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleRushFeeStudentSizeChange"
                                            @current-change="handleRushFeeStudentCurrentChange"
                                            :current-page="rushFee_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="rushFee_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        拒绝-{{reject_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}" >
                            <vue-scroll :ops="$ops">
                                <el-card class="student-card" shadow="hover" v-for="(reject_student,index) in reject_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(reject_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{reject_student.name}}
                                                </div>
                                                <div>
                                                    {{reject_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{reject_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleRejectStudentSizeChange"
                                            @current-change="handleRejectStudentCurrentChange"
                                            :current-page="reject_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="reject_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        未满足-{{continue_less_five_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}" >
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(continue_less_five_student,index) in continue_less_five_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(continue_less_five_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{continue_less_five_student.name}}
                                                </div>
                                                <div>
                                                    {{continue_less_five_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{continue_less_five_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleContinueLessFiveStudentSizeChange"
                                            @current-change="handleContinueLessFiveStudentCurrentChange"
                                            :current-page="continue_less_five_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="continue_less_five_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet  m-portlet--head-sm m-b-0" :style="{'height':clientHeight-100+'px'}" style="margin-left: 10px;width:300px">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        满足-{{continue_more_five_student_total}}人
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body m-portlet__body--small-padding" :style="{'height':clientHeight-186+'px'}" >
                            <vue-scroll :ops="$ops" >
                                <el-card class="student-card" shadow="hover" v-for="(continue_more_five_student,index) in continue_more_five_students" :key="index" >
                                    <div class="item" @click="handleRenewDetail(continue_more_five_student)">
                                        <div style="display: flex; flex-direction: column ">
                                            <div style="display: flex; flex-direction: row;justify-content:space-between">
                                                <div>
                                                    {{continue_more_five_student.name}}
                                                </div>
                                                <div>
                                                    {{continue_more_five_student.id}}
                                                </div>
                                            </div>
                                            <div>
                                                {{continue_more_five_student.edu}}
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                            </vue-scroll>
                            <div class="m-portlet__foot" style="padding: 5px">
                                <!--分页-->
                                <div class="text-center m-t-10">
                                    <el-pagination
                                            small
                                            background
                                            @size-change="handleContinueMoreFiveStudentSizeChange"
                                            @current-change="handleContinueMoreFiveStudentCurrentChange"
                                            :current-page="continue_more_five_student_currentPage"
                                            :page-size="10"
                                            :pager-count="5"
                                            layout="prev, pager, next"
                                            :total="continue_more_five_student_total">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vue-scroll>
        </div>

        <el-drawer
                :title="title"
                :visible.sync="drawer"
                :direction="direction"
                size="70%"
                >
<!--            <RenewDetail v-if="drawer"></RenewDetail>-->
            <Second_RenewDetail v-if="drawer"></Second_RenewDetail>
        </el-drawer>
    </div>

</template>

<script>
    import RenewDetail from "./component/RenewDetail";
    import Second_RenewDetail from "./component/Second_RenewDetail";
    export default {
        name: "List",
        data(){
            return{
                path: '/student/renew',
                title:'',
                drawer: false,
                direction: 'rtl',

                filter:{
                    grade_id: '',
                    school_id: '',
                    headTeacher_id: '',
                    student_id:'',
                },
                schools:[],
                grades:[],
                headTeachers:[],
                students:[],

                //未开始
                no_start_students:[],
                no_start_student_total:0,
                no_start_student_currentPage: 1,
                no_start_student_currentPageSize: 10,


                //犹豫
                hesitate_students:[],
                hesitate_student_total:0,
                hesitate_student_currentPage: 1,
                hesitate_student_currentPageSize: 10,

                //预约到店
                appoint_students:[],
                appoint_student_total:0,
                appoint_student_currentPage: 1,
                appoint_student_currentPageSize: 10,

                //已明确意向
                clearIntention_students:[],
                clearIntention_student_total:0,
                clearIntention_student_currentPage: 1,
                clearIntention_student_currentPageSize: 10,

                //催费
                rushFee_students:[],
                rushFee_student_total:0,
                rushFee_student_currentPage: 1,
                rushFee_student_currentPageSize: 10,

                //拒绝
                reject_students:[],
                reject_student_total:0,
                reject_student_currentPage: 1,
                reject_student_currentPageSize: 10,


                //满足
                continue_more_five_students:[],
                continue_more_five_student_total:0,
                continue_more_five_student_currentPage: 1,
                continue_more_five_student_currentPageSize: 10,

                //未满足
                continue_less_five_students:[],
                continue_less_five_student_total:0,
                continue_less_five_student_currentPage: 1,
                continue_less_five_student_currentPageSize: 10,

                choose_student_id:'',
                renewDetail:'',
                status:'',
                renewDetail_loading:false,
                innerDrawer:false,
            }
        },
        components: {
            'RenewDetail':RenewDetail,
            'Second_RenewDetail':Second_RenewDetail
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleList()
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleList() {
                this.$wApi.send(this.path, 'list', {
                    'currentPage': 1,
                    'currentPageSize': 10,
                    'filter': this.filter,
                })
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.schools=data.schools;
                        this.grades=data.grades;
                        this.headTeachers=data.headTeachers;
                        this.students=data.students;
                        break;
                    case 'list':
                        if (Object.keys(data.no_start_students).length > 0) {
                            this.no_start_students = data.no_start_students;
                        } else {
                            this.no_start_students = new Object();
                        }
                        this.no_start_student_total=data.no_start_student_total;

                        if (Object.keys(data.hesitate_students).length > 0) {
                            this.hesitate_students = data.hesitate_students;
                        } else {
                            this.hesitate_students = new Object();
                        }
                        this.hesitate_student_total=data.hesitate_student_total;

                        if (Object.keys(data.appoint_students).length > 0) {
                            this.appoint_students = data.appoint_students;
                        } else {
                            this.appoint_students = new Object();
                        }
                        this.appoint_student_total=data.appoint_student_total;

                        if (Object.keys(data.clearIntention_students).length > 0) {
                            this.clearIntention_students = data.clearIntention_students;
                        } else {
                            this.clearIntention_students = new Object();
                        }
                        this.clearIntention_student_total=data.clearIntention_student_total;

                        if (Object.keys(data.reject_students).length > 0) {
                            this.reject_students = data.reject_students;
                        } else {
                            this.reject_students = new Object();
                        }
                        this.reject_student_total=data.reject_student_total;

                        if (Object.keys(data.rushFee_students).length > 0) {
                            this.rushFee_students = data.rushFee_students;
                        } else {
                            this.rushFee_students = new Object();
                        }
                        this.rushFee_student_total=data.rushFee_student_total;

                        if (Object.keys(data.continue_more_five_students).length > 0) {
                            this.continue_more_five_students = data.continue_more_five_students;
                        } else {
                            this.continue_more_five_students = new Object();
                        }
                        this.continue_more_five_student_total=data.continue_more_five_student_total;

                        if (Object.keys(data.continue_less_five_students).length > 0) {
                            this.continue_less_five_students = data.continue_less_five_students;
                        } else {
                            this.continue_less_five_students = new Object();
                        }
                        this.continue_less_five_student_total=data.continue_less_five_student_total;
                        break;
                    case 'get_no_start_student_list':
                        if (Object.keys(data.no_start_students).length > 0) {
                            this.no_start_students = data.no_start_students;
                        } else {
                            this.no_start_students = new Object();
                        }
                        this.no_start_student_total=data.no_start_student_total;
                        break;
                    case 'get_hesitate_student_list':
                        if (Object.keys(data.hesitate_students).length > 0) {
                            this.hesitate_students = data.hesitate_students;
                        } else {
                            this.hesitate_students = new Object();
                        }
                        this.hesitate_student_total=data.hesitate_student_total;
                        break;
                    case 'get_appoint_student_list':
                        if (Object.keys(data.appoint_students).length > 0) {
                            this.appoint_students = data.appoint_students;
                        } else {
                            this.appoint_students = new Object();
                        }
                        this.appoint_student_total=data.appoint_student_total;
                        break;
                    case 'get_clearIntention_student_list':
                        if (Object.keys(data.clearIntention_students).length > 0) {
                            this.clearIntention_students = data.clearIntention_students;
                        } else {
                            this.clearIntention_students = new Object();
                        }
                        this.clearIntention_student_total=data.clearIntention_student_total;
                        break;
                    case 'get_reject_student_list':
                        if (Object.keys(data.reject_students).length > 0) {
                            this.reject_students = data.reject_students;
                        } else {
                            this.reject_students = new Object();
                        }
                        this.reject_student_total=data.reject_student_total;
                        break;
                    case 'get_rushFee_student_list':
                        if (Object.keys(data.rushFee_students).length > 0) {
                            this.rushFee_students = data.rushFee_students;
                        } else {
                            this.rushFee_students = new Object();
                        }
                        this.rushFee_student_total=data.rushFee_student_total;
                        break;
                    case 'get_continue_more_five_student_list':
                        if (Object.keys(data.continue_more_five_students).length > 0) {
                            this.continue_more_five_students = data.continue_more_five_students;
                        } else {
                            this.continue_more_five_students = new Object();
                        }
                        this.continue_more_five_student_total=data.continue_more_five_student_total;
                        break;
                    case 'get_continue_less_five_student_list':
                        if (Object.keys(data.continue_less_five_students).length > 0) {
                            this.continue_less_five_students = data.continue_less_five_students;
                        } else {
                            this.continue_less_five_students = new Object();
                        }
                        this.continue_less_five_student_total=data.continue_less_five_student_total;
                        break;
                    case 'get_renew_detail':
                        this.renewDetail_loading=false;
                        this.renewDetail=data.studentRenew
                        break;
                    case 'get_new_renew_detail':
                        this.renewDetail_loading=false;
                        this.renewDetail=data.studentRenew

                        if(this.renewDetail.recommendRenew.length==0){
                            this.renewDetail.recommendRenew = new Object();
                        }
                        break;
                    case 'store_student_renew_time':
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });

                        this.innerDrawer=false
                        if (Object.keys(this.renewDetail.studentRenewTimes).length == 0) {
                            this.renewDetail.studentRenewTimes = new Object();
                        }
                        if (Object.keys(this.renewDetail.logs).length == 0) {
                            this.renewDetail.logs = new Object();
                        }
                        this.$set(this.renewDetail.studentRenewTimes,data.studentRenewTime.id,data.studentRenewTime)
                        this.$set(this.renewDetail.logs,data.log.id,data.log)

                        break;
                    case 'change_attitude':
                        this.$message({
                            message: '流转成功',
                            type: 'success'
                        });

                        if(data.first_status=='active'){
                            this.$delete(this.no_start_students,data.student_id)
                            this.no_start_student_total--
                        }
                        else if(data.first_status=='hesitate'){
                            this.$delete(this.hesitate_students,data.student_id)
                            this.hesitate_student_total--
                        }
                        else if(data.first_status=='appoint'){
                            this.$delete(this.appoint_students,data.student_id)
                            this.appoint_student_total--
                        }
                        else if(data.first_status=='reject'){
                            this.$delete(this.reject_students,data.student_id)
                            this.reject_student_total--
                        }
                        else if(data.first_status=='rushFee'){
                            this.$delete(this.rushFee_students,data.student_id)
                            this.rushFee_student_total--
                        }

                        if(data.status=='active'){
                            this.$set(this.no_start_students,data.student.id,data.student)
                            this.no_start_student_total++
                        }
                        else if(data.status=='hesitate'){
                            this.$set(this.hesitate_students,data.student.id,data.student)
                            this.hesitate_student_total++
                        }
                        else if(data.status=='appoint'){
                            this.$set(this.appoint_students,data.student.id,data.student)
                            this.appoint_student_total++
                        }
                        else if(data.status=='reject'){
                            this.$set(this.reject_students,data.student.id,data.student)
                            this.reject_student_total++
                        }
                        else if(data.status=='rushFee'){
                            this.$set(this.rushFee_students,data.student.id,data.student)
                            this.rushFee_student_total++
                        }

                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchStudent':
                        this.students = data.searchData;
                        break;
                    case 'update_student_renew_time':
                        if(data.status=='finished'){
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        break;
                    case 'update_new_student_renew_time':
                        if(data.status=='finished') {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        }
                        if(data.first_status!=data.second_status){

                            if(data.first_status=='active'){
                                this.$delete(this.no_start_students,data.student_id)
                                this.no_start_student_total--
                            }
                            else if(data.first_status=='hesitate'){
                                this.$delete(this.hesitate_students,data.student_id)
                                this.hesitate_student_total--
                            }
                            else if(data.first_status=='appoint'){
                                this.$delete(this.appoint_students,data.student_id)
                                this.appoint_student_total--
                            }
                            else if(data.first_status=='reject'){
                                this.$delete(this.reject_students,data.student_id)
                                this.reject_student_total--
                            }
                            else if(data.first_status=='rushFee'){
                                this.$delete(this.rushFee_students,data.student_id)
                                this.rushFee_student_total--
                            }
                            else if(data.first_status=='clearIntention'){
                                this.$delete(this.clearIntention_students,data.student_id)
                                this.clearIntention_student_total--
                            }

                            if(data.second_status=='active'){
                                this.$set(this.no_start_students,data.student.id,data.student)
                                this.no_start_student_total++
                            }
                            else if(data.second_status=='hesitate'){
                                this.$set(this.hesitate_students,data.student.id,data.student)
                                this.hesitate_student_total++
                            }
                            else if(data.second_status=='appoint'){
                                this.$set(this.appoint_students,data.student.id,data.student)
                                this.appoint_student_total++
                            }
                            else if(data.second_status=='reject'){
                                this.$set(this.reject_students,data.student.id,data.student)
                                this.reject_student_total++
                            }
                            else if(data.second_status=='rushFee'){
                                this.$set(this.rushFee_students,data.student.id,data.student)
                                this.rushFee_student_total++
                            }
                            else if(data.second_status=='clearIntention'){
                                this.$set(this.clearIntention_students,data.student.id,data.student)
                                this.clearIntention_student_total++
                            }
                        }
                        break;
                }
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },
            handleSearchStudent(query){
                this.$wApi.send(this.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
            handleRenewDetail(student){
                this.title=student.name
                this.choose_student_id=student.id
                this.status=student.status
                this.drawer=true
            },
            handleNoStartStudentSizeChange(val){
                this.no_start_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_no_start_student_list', {
                    'currentPage': this.no_start_student_currentPage,
                    'currentPageSize': this.no_start_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleNoStartStudentCurrentChange(val){
                this.no_start_student_currentPage=val;
                this.$wApi.send(this.path, 'get_no_start_student_list', {
                    'currentPage': this.no_start_student_currentPage,
                    'currentPageSize': this.no_start_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleHesitateStudentSizeChange(val){
                this.hesitate_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_hesitate_student_list', {
                    'currentPage': this.hesitate_student_currentPage,
                    'currentPageSize': this.hesitate_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleHesitateStudentCurrentChange(val){
                this.hesitate_student_currentPage=val;
                this.$wApi.send(this.path, 'get_hesitate_student_list', {
                    'currentPage': this.hesitate_student_currentPage,
                    'currentPageSize': this.hesitate_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleAppointStudentSizeChange(val){
                this.appoint_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_appoint_student_list', {
                    'currentPage': this.appoint_student_currentPage,
                    'currentPageSize': this.appoint_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleAppointStudentCurrentChange(val){
                this.appoint_student_currentPage=val;
                this.$wApi.send(this.path, 'get_appoint_student_list', {
                    'currentPage': this.appoint_student_currentPage,
                    'currentPageSize': this.appoint_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleRushFeeStudentSizeChange(val){
                this.rushFee_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_rushFee_student_list', {
                    'currentPage': this.rushFee_student_currentPage,
                    'currentPageSize': this.rushFee_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleRushFeeStudentCurrentChange(val){
                this.rushFee_student_currentPage=val;
                this.$wApi.send(this.path, 'get_rushFee_student_list', {
                    'currentPage': this.rushFee_student_currentPage,
                    'currentPageSize': this.rushFee_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleClearIntentionStudentSizeChange(val){
                this.clearIntention_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_clearIntention_student_list', {
                    'currentPage': this.clearIntention_student_currentPage,
                    'currentPageSize': this.clearIntention_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleClearIntentionStudentCurrentChange(val){
                this.clearIntention_student_currentPage=val;
                this.$wApi.send(this.path, 'get_clearIntention_student_list', {
                    'currentPage': this.clearIntention_student_currentPage,
                    'currentPageSize': this.clearIntention_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleRejectStudentSizeChange(val){
                this.reject_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_reject_student_list', {
                    'currentPage': this.reject_student_currentPage,
                    'currentPageSize': this.reject_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleRejectStudentCurrentChange(val){
                this.reject_student_currentPage=val;
                this.$wApi.send(this.path, 'get_reject_student_list', {
                    'currentPage': this.reject_student_currentPage,
                    'currentPageSize': this.reject_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleContinueMoreFiveStudentSizeChange(val){
                this.continue_more_five_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_continue_more_five_student_list', {
                    'currentPage': this.continue_more_five_student_currentPage,
                    'currentPageSize': this.continue_more_five_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleContinueMoreFiveStudentCurrentChange(val){
                this.continue_more_five_student_currentPage=val;
                this.$wApi.send(this.path, 'get_continue_more_five_student_list', {
                    'currentPage': this.continue_more_five_student_currentPage,
                    'currentPageSize': this.continue_more_five_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleContinueLessFiveStudentSizeChange(val){
                this.continue_less_five_student_currentPageSize=val;
                this.$wApi.send(this.path, 'get_continue_less_five_student_list', {
                    'currentPage': this.continue_less_five_student_currentPage,
                    'currentPageSize': this.continue_less_five_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleContinueLessFiveStudentCurrentChange(val){
                this.continue_less_five_student_currentPage=val;
                this.$wApi.send(this.path, 'get_continue_less_five_student_list', {
                    'currentPage': this.continue_less_five_student_currentPage,
                    'currentPageSize': this.continue_less_five_student_currentPageSize,
                    'filter': this.filter,
                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            handleExcel() {
                if(this.powers.includes(180)){
                    var all_student=1
                }else{
                    var all_student=0
                }
                window.open('http://server.modijiaoyu.com'+'/renewExcel?grade_id='+this.filter.grade_id+
                    '&school_id='+this.filter.school_id+
                    '&headTeacher_id='+this.filter.headTeacher_id+
                    '&student_id='+this.filter.student_id+
                    '&all_student='+all_student);
            },
        }
    }
</script>


<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
    .m-portlet__body{
        .student-card{
            margin: 10px 0;
            /deep/.el-card__body{
                padding: 10px;
            }
        }
    }


</style>